import { uuidValidator } from './uuid';
export const principalIdValidator = (params) => uuidValidator(params);
